import mq from 'js-mq';
import $ from 'jquery';

$(_ => {

  const $navSub = $('#nav-sub');

  if ($navSub.length === 0) return;

  let isMobile = false;
  const $container = $('#nav-sub-container');
  const $containerMobile = $('#nav-sub-container-mobile');

  mq.on('xs',
    _ => {
      if (!isMobile) {
        window.requestAnimationFrame(_ => {
          $containerMobile.append($navSub);
          isMobile = true;
        });
      }
    },
    _ => {
      if (isMobile) {
        window.requestAnimationFrame(_ => {
          $container.append($navSub);
          isMobile = false;
        });
      }
  });

});